import {renderEmployeeItem, renderEmployeesContainer, renderEmployeeServices} from "../utils/templates";

export default class EmployeesStep {
  constructor() {
    this.id = "employees";
    this.title_key = "choose_specialist";
  }

  init({ $, state, data, emit }) {
    this.$ = $
    this.state = state;
    this.data = data;
    this.emit = emit;
    this.selected = state.selectedEmployee || null;
  }

  getAvailableEmployees() {
    if (this.state.stepContext.employeesFirst) {
      return this.data.employees; // don't filter
    }

    const selectedServiceIds = this.state.selectedServices;
    return this.data.employees.filter(emp => {
      const employeeJobIds = new Set(emp.specialistJob.map(job => job.id));
      return selectedServiceIds.every(id => employeeJobIds.has(id));
    });
  }

  render(container) {
    const employeesToShow = this.getAvailableEmployees();
    const showServices = this.data.config.show_employee_services === 1;

    if(this.selected == null && employeesToShow.length === 1) {
      this.selected = employeesToShow[0].id;
      this.next();
      return; // Skip render and jump to next step
    }

    const employeesHtml = employeesToShow.map(employee => {
      const employeeObj = {
        id: employee.id,
        name: employee.name,
        avatar: employee.avatar, // assuming it's already resolved, equivalent to `$employ->getAvatar()`
        specialistJob: employee.specialistJob, // array of { name }
        reviewScore: employee.reviewScore,
      }
      return renderEmployeeItem({
        employee: employeeObj,
        servicesHtml: showServices ? renderEmployeeServices(employeeObj) : '',
        rating: employee.reviewScore || null
      });
    }).join('');

    const html = renderEmployeesContainer({
      employeesHtml: employeesHtml,
    });

    container.html(html);

    // bind click events after render
    container.find('.step-specialist-block').on('click', (e) => {
      this.selected = parseInt($(e.currentTarget).data('specialist-id'), 10);
      // container.empty();           // clear current list
      // this.render(container);      // re-render only selected
      this.next();                 // move to next step
    });
  }

  next() {
    if(this.selected) {
      this.state.selectedEmployee = this.selected;
      if(this.state.stepContext.employeesFirst) {
        // Reset services selection
        this.state.selectedServices = null;
      }
      this.emit('employee_selected', this.selected);
    }
  }
};